/*
 *
 * PublicViewEvent
 *
 */

import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import throttle from 'helpers/throttle';

import setLanguageContent from 'helpers/setLanguageContent';
import handleAnalytics from 'helpers/handleAnalytics';
import {
  selectCurrentPage,
  setSectionsContent
} from './helpers';

import PublicViewEventWrapperNotFound from './styles/PublicViewEventWrapperNotFound';

import RendererComponent from './RendererComponent';



window.anonUserIdString;


window.guessTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;


window.isInitial = true;



window.urlSearchParams = {};

const urlSearch = new URLSearchParams(window.location.search);

if (urlSearch) {
  urlSearch.forEach(function (val, key) {
    if (key.includes('utm_')) window.urlSearchParams[key] = val;
  });  
}

function getPageSlug(params, thisEventData) {
  
  if (!thisEventData) return;

  const {
    pageSlug
  } = params;

  const thisPageSlug = pageSlug === 'location' ? '/' : pageSlug ? pageSlug : '/';
  return selectCurrentPage(thisEventData, thisPageSlug);

}

function handleResize() {
  const windowWidthInner = window.innerWidth;

  let thisSize = '';

  if (windowWidthInner <= 600) {
    thisSize = '37_5';
  } else if (windowWidthInner <= 1228) {
    thisSize = '76_8';
  }

  return thisSize;
}

function PublicViewEvent(props) {

  const thisEventData = props.eventData ? props.eventData : window.eventData;
  const templateSchema = thisEventData?.template?.templateSchema;

  const {
    params      
  } = props;

  const {
    chapterSlug,
    pageSlug,
    secondSlug
  } = params;


  const currentPage = getPageSlug(params, thisEventData)?.pageId;
  const sectionsData = setSectionsContent(props, templateSchema, currentPage);
  const [windowWidth, setWindowWidth] = useState(handleResize());

  useEffect(() => {
    const currentContent = {...props, ...sectionsData, pagePath: window.location.pathname, href: window.location.href};
    if (isInitial) handleAnalytics(currentContent, isInitial, null, false);

    function resizeEvent() {
      setWindowWidth(handleResize());
    }

    window.addEventListener('resize', throttle(resizeEvent, 1));

    return () => window.removeEventListener('resize', throttle(resizeEvent, 1));
  }, []); 





  return (    
    <div id={'PublicViewEventWrapper-id'}>
      {
        templateSchema && templateSchema.customStyles && templateSchema.customStyles.defaultFont ? (
          <style>
            {`
              #PublicViewEventWrapper-id {
                font-family:${templateSchema.customStyles.defaultFont};
              }
            `}
          </style>
        ): ''
      }
      {templateSchema && templateSchema.templateId && currentPage ? (
        <>
          {/* <Helmet
            title={sectionsData.title}
            meta={[
              { name: 'description', content: sectionsData.description},
            ]}
          /> */}
          {currentPage ? sectionsData?.sections?.map((section, indexSection) => {
            if (section) {
              return (
                <RendererComponent
                  section={section}
                  templateSchema={templateSchema}
                  pageSlug={pageSlug}
                  secondSlug={secondSlug}
                  chapterSlug={chapterSlug}
                  params={params}
                  windowWidth={windowWidth}
                  currentPage={currentPage}
                  key={`PublicViewEvent-RendererComponent-`+section.sectionId}
                  thisSectionData={section}
                  indexSection={indexSection}
                />
              );
            }
          }) : ''}
        </>
      ) : (
        <>
          {/* <Helmet
            title={setLanguageContent(templateSchema, templateSchema?.metaTitle ? 'metaTitle' : 'title')}
            meta={[
              { name: 'description', content: templateSchema?.metaDescription },
            ]}
          /> */}
          <PublicViewEventWrapperNotFound>{window.errorTextVar ? window.errorTextVar : '404 - Nothing here... :('} <br/><br/>Go back to <a href={'https://acara.io/'} rel={'noopener'} >Acara</a></PublicViewEventWrapperNotFound>     
        </>
      )}
    </div>
  );
}

export default PublicViewEvent;


